import React from "react";
import Common_Title from "../../common-components/common-btn/common-title/Common_Title";
import "./Core_Features.css";
import Common_Heading from "../../common-components/common-heading/Common_Heading";
import Common_Card from "../../common-components/common-card/Common_Card";

function Core_Features() {
  const featuresData = [
    {
      id: 1,
      icon: "/assets/images/about-us/ACCESSIBILITY.png",
      t1: "ACCESSIBILITY",
      desc:
        " Designed for everyone, from beginners to seasoned pros. Our UI is built for speed and ease of use.",
    },
    {
      id: 2,
      icon: "/assets/images/winning-edge/engagement.png",
      t1: "FUN & ENGAGING",

      desc:
        " Daily contest & instant rewards that keep the excitement alive.Experience the thrill of every wicket and boundary.",
    },
    {
      id: 3,
      icon: "/assets/images/about-us/group-users.png",
      t1: "COMMUNITY DRIVEN",

      desc: " Join a growing network of cricket enthusiast across the globe.",
    },
  ];
  return (
    <section className="core-features-section">
      <div className="container">
        <div className="row align-items-center mb-5">
          <div className="col-lg-6 col-md-8">
            <div className="core-features-heading">
              <Common_Heading
                head1="ENGINEERED"
                head2="FOR THE WIN"
                title_text="CORE FEATURES?"
              />
            </div>
          </div>
        </div>

        <div className="row">
          {featuresData.map((item) => (
            <div className="col-lg-4 col-md-6 mb-4" key={item.id}>
              <Common_Card
                icon={item.icon}
                titleLine1={item.t1}
                titleLine2={item.t2}
                description={item.desc}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Core_Features;
